export const checkinModalGlobal = {
  header: {
    phone: "الهاتف",
    accommodation: "مكان الإقامة",
    checkin: "تسجيل الوصول",
    booking: "الحجز",
    notAvailable: "غير متاح",
    notLinked: "غير مرتبط",
    defaultGuestName: "ضيف",
  },
  roles: {
    botStaff: "البوت / الموظفون",
    guest: "الضيف",
  },
  media: {
    imageAlt: "صورة مُرسلة",
    locationReceived: "📍 تم استلام الموقع",
    openInMaps: "افتح في خرائط Google",
    viewCoordinates: "عرض الإحداثيات ({lat}، {lng})",
    viewFile: "عرض الملف",
    document: "مستند",
  },
  dropzone: {
    text: "أفلت لإرفاق الملفات",
  },
  failure: {
    notSent: "لم تُرسل",
    notSentDefault: "لم تُرسل",
    reasons: {
      paymentIssue: "مشكلة في الدفع في حساب WhatsApp",
      cannotReceive: "لا يمكن للرقم استقبال WhatsApp",
      downloadFailed: "تعذّر على WhatsApp تنزيل الملف",
      templateMissingData: "بيانات ناقصة في القالب",
      requirementsNotMet: "الرسالة لا تستوفي متطلبات WhatsApp",
    },
  },
  mode: {
    ai: "ذكاء اصطناعي",
    manual: "يدوي",
    autoReplyBanner: "يقوم الوكيل بالرد على هذا الضيف تلقائيًا.",
  },
  predefined: {
    header: "الردود المُعدّة مسبقًا",
    empty: "لم يتم العثور على ردود مُعدّة مسبقًا",
  },
  input: {
    attachFile: "إرفاق ملف",
    placeholder: "ابدأ بـ / لاختيار رد مُعدّ مسبقًا.",
    removeFile: "إزالة الملف",
  },
  toasts: {
    noBookingLinkedSummary: "لا يوجد حجز مرتبط",
    noBookingLinkedDetail: "لا يوجد حجز مرتبط بهذه المحادثة",
    errorSummary: "خطأ",
    userIdError: "تعذّر الحصول على معرّف المستخدم",
    manualModeSummary: "تم تفعيل الوضع اليدوي",
    aiModeSummary: "تم تفعيل وكيل الذكاء الاصطناعي",
    manualModeDetail: "ستقوم بالرد على الرسائل يدويًا",
    aiModeDetail: "سيقوم البوت بالرد تلقائيًا",
    modeChangeError: "تعذّر تغيير وضع المحادثة",
    reactivateIdError: "تعذّر تحديد المحادثة لإعادة تنشيطها.",
    successSummary: "نجاح",
    templateSentOk: "تم إرسال القالب بنجاح.",
    templateSentError: "تعذّر إرسال قالب إعادة التنشيط.",
    fileTypeSummary: "نوع الملف غير مسموح به",
    fileTypeDetail: "{name} ليس صورة أو ملف PDF.",
    fileSizeSummary: "الملف كبير جدًا",
    fileSizeDetail: "{name} يتجاوز حد 5 ميغابايت.",
    sendError: "تعذّر إرسال الرسالة",
  },
};
